<template>
  <a-layout>
    <a-layout-content style="padding: 0 50px">
      <a-page-header
          :title="name"
          :sub-title="'试卷《' + bookName + '》'"
      >
        <template slot="extra">
          <a-button @click="downLoad">
            下载笔记
          </a-button>
        </template>
      </a-page-header>
<!--      <div :style="{ paddingBottom: '14px' }">-->
<!--        <span>单选 【20】</span>-->
<!--        <span>多选 【20】</span>-->
<!--        <span>填空 【20】</span>-->
<!--        <span>判断 【20】</span>-->
<!--        <span>简单 【20】</span>-->
<!--      </div>-->
      <div :style="{ background: '#fff', padding: '24px 50px', minHeight: '380px' }">
        <a-list :data-source="questions">
          <a-list-item slot="renderItem" slot-scope="item">
            <a-list-item-meta v-if="item.stype == 1">
              <div class="zhangTitle" slot="title">
                <span style="flex: 1">{{ item.name }}</span>
<!--                <a-button>编辑章</a-button>-->
              </div>
            </a-list-item-meta>
            <a-list-item-meta v-if="item.stype == 2">
              <div class="jieTitle" slot="title">
                <span style="flex: 1">{{ item.name }}</span>
<!--                <a-button>编辑节</a-button>-->
              </div>
            </a-list-item-meta>
            <a-list-item-meta v-if="item.stype == 3">
              <div class="qcnt flex" slot="title">
                <div class="flex flex1">
                  {{ item.keys }}. <div v-html="item.title"></div>
                </div>
<!--                <a-button>编辑单题</a-button>-->
              </div>
              <div class="qcnt description" slot="description">
                <div v-if="item.type == 'single_choice'">
                  <div v-for="(option, index) in item.content" :key="index" :class="item.consult == option.key?'red':''">
                    {{ option.key }}. {{ option.item }}
                  </div>
                </div>
                <div v-if="item.type == 'multiple_choice'">
                  <div v-for="(option, index) in item.content" :key="index" :class="item.consult.includes(option.key)?'red':''">
                    {{ option.key }}. {{ option.item }}
                  </div>
                </div>
                <div v-if="item.type == 'jud_question'">
                   <div :class="item.consult == 1?'red':''">对</div>
                   <div :class="item.consult == 2?'red':''">错</div>
                </div>
                <div class="flex" v-if="item.type == 'answer'">
                  答: <div v-html="item.analysis"></div>
                </div>
              </div>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </div>
    </a-layout-content>
  </a-layout>
</template>
<script>
    import {BaseUrl, getBookQuestionsList, downBookQuestion} from '@/libs/api'
    import moment from 'moment'
    export default {
        name: 'showPaper',
        data(){
            return{
                name: '',
                bookName: '',
                bookId: '',
                data: [],
                questions: [],
                statics: [],
                typeList: {
                  'single_choice': '单选题',
                  'multiple_choice': '多选题',
                  'jud_question': '判断题',
                  'fill': '填空题',
                  'answer': '简答题',
                }
            }
        },
        mounted(){
          if (this.$route.query.bookId) {
            this.bookId = this.$route.query.bookId;
            this.name = this.$route.query.name;
            this.bookName = this.$route.query.bookName;
            this.$nextTick(()=>{
              this.getData()
            })
          }
        },
        methods:{
            moment,
            getData(){
                this.loading = true;
                let request= { bookId: this.bookId }
                getBookQuestionsList(request).then(res=>{
                    this.questions = res.list
                    this.statics = res.data
                }).catch(error=>{
                    console.log(error)
                })
            },
            downLoad(){
              downBookQuestion({bookId: this.bookId}).then(res=>{
                if(res){
                  let downUrl = BaseUrl+res;
                  window.open(downUrl);
                }
              },error=>{
                console.log(error)
                this.loading=false
              })
            }
        }
    }
</script>
<style lang="less" scoped>
  .flex{
    display: flex
  }
  .zhangTitle{
    display: flex;
  }
  .jieTitle{
    display: flex;
    padding-left: 30px;
  }
  .count{
    font-size: 10px;
    padding-left: 10px;
    color: #5482e1;
    font-weight: 600;
  }
  .qcnt{
    padding-left: 60px;
  }
  .red{
    color: #ff5f4e;
  }
  .juice{
        color: #FF5722;
    }
</style>
